// Import api models.
import {
	BuildingResponseCommercialExisting,
} from '@app/models/api';
import ComparisonSummaryEntities, {
	ComparisonSummaryEntitiesParameters
} from './ComparisonSummaryEntities';

interface ComparisonSummaryBuildingsParameters extends ComparisonSummaryEntitiesParameters<BuildingResponseCommercialExisting> {
	oldHasFloodPerilSelected: boolean;
	newHasFloodPerilSelected: boolean;
}

export default class ComparisonSummaryBuildings extends ComparisonSummaryEntities<BuildingResponseCommercialExisting> {
	public oldHasFloodPerilSelected: boolean;
	public newHasFloodPerilSelected: boolean;

	public constructor({ oldHasFloodPerilSelected, newHasFloodPerilSelected, ...other }: ComparisonSummaryBuildingsParameters) {
		super(other);
		this.oldHasFloodPerilSelected = oldHasFloodPerilSelected;
		this.newHasFloodPerilSelected = newHasFloodPerilSelected;
	}

}